export function hasPassedDate(dateISO) {
  const currentDate = new Date();
  const comparisonDate = new Date(dateISO);
  let offset = new Date().getTimezoneOffset() * 60000;
  if (import.meta.env.VITE_TEST_MODE === "true") {
    offset = 0;
  }
  return comparisonDate < (currentDate - offset);
}
